import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { PersonTypeRulesApi } from "../../api/PersonTypeRulesApi";
import type { PersonRef } from "../../generated/dto/PersonRef";
import type { PersonTypeMask } from "../../generated/dto/PersonTypeMask";
import type { PersonTypeRulesValidatePersonRequest } from "../../generated/dto/PersonTypeRulesValidatePersonRequest";
import type { PersonTypeValidation } from "../../generated/dto/PersonTypeValidation";

export class PersonTypeRulesApiClient implements PersonTypeRulesApi {
  constructor(private readonly client = useClient()) {}

  async masksPublic(): Promise<Array<PersonTypeMask>> {
    const { data } = await this.client.get<unknown>(`/persontyperules/public/masks`);
    return deserializeCbiDto<Array<PersonTypeMask>>(data, "generated.dto.PersonTypeMask");
  }

  async masksStaff(): Promise<Array<PersonTypeMask>> {
    const { data } = await this.client.get<unknown>(`/persontyperules/staff/masks`);
    return deserializeCbiDto<Array<PersonTypeMask>>(data, "generated.dto.PersonTypeMask");
  }

  async masksMember(): Promise<Array<PersonTypeMask>> {
    const { data } = await this.client.get<unknown>(`/persontyperules/member/masks`);
    return deserializeCbiDto<Array<PersonTypeMask>>(data, "generated.dto.PersonTypeMask");
  }

  async validateAssignedTypeStaff(person: PersonRef): Promise<PersonTypeValidation> {
    const { data } = await this.client.post<unknown>(`/persontyperules/staff/validateassignedtype`, serializeCbiDto(person, "generated.dto.PersonRef"));
    return deserializeCbiDto<PersonTypeValidation>(data, "generated.dto.PersonTypeValidation");
  }

  async validatePersonStaff(request: PersonTypeRulesValidatePersonRequest): Promise<PersonTypeValidation> {
    const { data } = await this.client.post<unknown>(`/persontyperules/staff/validateperson`, serializeCbiDto(request, "generated.dto.PersonTypeRulesValidatePersonRequest"));
    return deserializeCbiDto<PersonTypeValidation>(data, "generated.dto.PersonTypeValidation");
  }
}

export const usePersonTypeRulesApi = (): PersonTypeRulesApi => new PersonTypeRulesApiClient();
